const wishlists = {
  wishlists: JSON.parse(localStorage["vlorenkamer-wishlist"] ?? "[]"),
  wishlist_counter_element: document.querySelector(".wishlist-count-bubble"),
  add: function ({ variant_id, product_handle }) {
    const has_exist_variant = this.wishlists.some(
      (wishlist) => wishlist.variant_id == variant_id
    );
    if (has_exist_variant) return;
    this.wishlists.push({ variant_id, product_handle, quantity: 1 });
    this.save();
  },
  delete: function ({ variant_id }) {
    const variantIndex = this.wishlists.findIndex(
      (w) => w.variant_id == variant_id
    );

    if (variantIndex == -1) return;
    this.wishlists.splice(variantIndex, 1);
    this.save();
  },
  update: function ({ variant_id, count }) {
    const wishlist = this.wishlists.find((w) => w.variant_id == variant_id);
    if (!wishlist) return;

    wishlist.quantity = count < 1 ? 1 : count;
    this.save();
  },
  save: function (params) {
    localStorage["vlorenkamer-wishlist"] = JSON.stringify(this.wishlists);
    this.updateCounterView();
  },
  updateCounterView: function () {
    if (!this.wishlist_counter_element) return;
    this.wishlist_counter_element.innerText =
      this.wishlists.length == 0 ? "" : this.wishlists.length;
  },
  list: async function () {
    if (this.wishlists.length == 0) [];
    const wishlist_products = [];
    for (let { product_handle, variant_id, quantity } of this.wishlists) {
      const product = await fetch(`/products/${product_handle}.js`)
        .then((t) => t.json())
        .catch(() => {
          this.delete(variant_id);
        });
      product.quantity = quantity;
      product.variant_id = variant_id;
      wishlist_products.push(product);
    }
    return wishlist_products;
  },
  addToCart: function () {},
};

window.wishlist = Object.freeze(wishlists);
window.wishlist.updateCounterView();
